// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zTdq","colBig":"styles_colBig__Mf0YY","colSmall":"styles_colSmall__2XlbH","shopifyNameWrapper":"styles_shopifyNameWrapper__3lVok"};